export const RU_LANG_CODE = "ru"
export const TRANSLATIONS_RU = {
    welcome: "Welcome to the tutorial RU",
    backToMain: "Назад на сайт",
    backToShop: "Вернуться в магазин",
    paymentMethod:{
        title:"Способы оплаты",
        byCard:{
            title:"Картой онлайн",
            content:"Оплатите ежемесячную выплату по вашему кредиту картой любого банка РК",
            payBtn:{
                label:"продолжить"
            }
        },
        byKassa24:{
            title:"В терминале Касса24",
            content:"1. Подойдите к терминалу Касса24\n" +
                "2. Введите в поиске AIRBA Pay\n" +
                "3. В результатах поиска нажмите на AIRBA Pay\n" +
                "4. Введите ИИН на который вы оформляли кредит\n" +
                "5. Ознакомьтесь с информацией по кредиту\n" +
                "6. Внесите необходимую сумму для оплаты ежемесячного платежа и нажмите \"Оплатить\"\n" +
                "\n" +
                "!Терминал Касса24 не выдает сдачу.",
        },
        byYurta:{
            title:"В терминале Yurta",
            content:"1. Подойдите к любому терминалу Ю-Станция компании Yurta\n" +
                "2. Выберите раздел Ю-Финансы\n" +
                "3. Выберите подраздел Микрокредиты МКО и МФО\n" +
                "4. Выберите в списке AIRBA Pay\n" +
                "5. Введите ИИН на который вы оформляли кредит\n" +
                "6. Ознакомьтесь с информацией по кредиту\n" +
                "7. Внесите необходимую сумму для оплаты ежемесячного платежа и нажмите \"Оплатить\"\n" +
                "\n" +
                "!Терминал Ю-Станция не выдает сдачу.",
        }
    },
    paymentForm: {
        title: "Оплата кредита",
        iin: {
            label:"ИИН",
            placeholder: "Введите ваш ИИН",
        },
        smsCode: {
            label: "Введите SMS-код отправленный на номер",
            placeholder: "SMS-код",
        },
        sendBtn: {
            label: "Отправить",
        },
    },
    loanInfo: {
        title: "Оплата кредита",
        iin: "ИИН",
        monthlyPayment: {
            label:"Ежемесячный платеж до {{date}} составляет:",
        },
        kzt: {
            label:"тенге",
        },
        payBtn: {
            label:"Оплатить",
            hint:"Нажав на кнопку “оплатить” вы будете перенаправлены на страницу оплаты",
        },
        tryBtn: {
            label:"Попробовать еще раз",
        },
    },
    paymentResult: {
        title: "Оплата кредита",
        successMessage:"Поздравляем! Платеж погашен.",
        errorMessage:"Что то пошло не так :(",
        tryBtn: {
            label:"Попробовать еще раз",
        },
    },
    errors: {
        clientNotFound: "Клиент не найден",
        smsCodeWrong: "Неверный SMS-код",
        smsCodeSend: "Ошибка при отправке SMS-кода",
        smsCodeCheck: "Ошибка при проверке SMS-кода",
        getLoanInfo:"Ошибка получения информации о займе",
        getPaymentLink: "Ошибка получения ссылки на оплату",
    },
};